import React, { useState } from 'react';
import axios from 'axios';
import { useAuth } from '../context/AuthContext';
import Button from './Button';

export default function EmailVerificationBanner() {
  const { user, API_URL } = useAuth();
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  if (!user || user.is_email_verified) return null;
  if (user.auth_provider === 'google' || user.auth_provider === 'apple') return null;

  const handleResend = async () => {
    setSending(true);
    setError('');
    try {
      await axios.post(`${API_URL}/auth/resend-verification`, {}, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setSent(true);
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (err.response?.status === 429) {
        setError('Too many requests. Please wait a bit before resending.');
      } else {
        setError(detail || 'Could not send verification email. Please try again later.');
      }
    }
    setSending(false);
  };

  return (
    <div className="verification-banner" role="status">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
        <polyline points="22,6 12,13 2,6" />
      </svg>
      {/* Each message is its own keyed element, never bare sibling text nodes.
          Browser translation and iOS email auto-linking replace text nodes
          with their own elements; swapping a fragment of three text nodes
          for one string then made React remove nodes that were no longer
          there, and the whole page crashed (Sentry 7732067590). Replacing an
          element that is still a direct child is safe. */}
      <span className="verification-banner__text">
        {sent
          ? <span key="sent">Verification email sent. Check your inbox.</span>
          : error
          ? <span key="error">{error}</span>
          : <span key="prompt">Please verify your email address ({user.email}) to secure your account.</span>}
      </span>
      {!sent && (
        <Button
          type="button"
          variant="primary"
          size="sm"
          onClick={handleResend}
          loading={sending}
          loadingText="Sending…"
        >
          Resend email
        </Button>
      )}
    </div>
  );
}
